import { grey } from '@material-ui/core/colors';

export const itemBackground = grey['200'];
export const subText = grey['600'];

export const COLOR_PAGE_BACKGROUND = '#F5F6F7';
export const COLOR_CONTENT_BACKGROUND = '#FFFFFF';

export const COLOR_SIDEMENU_BACKGROUND = '#FFFFFF';
export const COLOR_SIDEMENU_CONTENT_SELECTED = '#F2F4F5';

export const COLOR_TEXT_MAIN = '#4C566C';
export const COLOR_TEXT_DISABLED = '#CACACA';
export const COLOR_TEXT_SECONDALY = '#2DCC70';

export const COLOR_MENU_BACKGROUND = '#FFFFFF';
export const COLOR_MENU_HEADER = '#F2F4F5';

export const COLOR_BUTTON_BACKGROUND_MAIN = '#4C566C';
export const COLOR_BUTTON_BACKGROUND_HOVER = '#333A48';
export const COLOR_BUTTON_BACKGROUND_DISABLED = '#F5F6F7';
export const COLOR_BUTTON_TEXT_MAIN = '#FFFFFF';
export const COLOR_BUTTON_TEXT_DISABLED = 'rgba(75, 85, 106, 0.08)';

export const COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN = '#FFFFFF';
export const COLOR_SECONDARY_BUTTON_BACKGROUND_DISABLED = '#F5F6F7';
export const COLOR_SECONDARY_BUTTON_TEXT_MAIN = '#4C566C';
export const COLOR_SECONDARY_BUTTON_TEXT_DISABLED = 'rgba(75, 85, 106, 0.08)';

export const COLOR_BORDER_PRIMARY = '#E6E7E8';
export const COLOR_BORDER_SECONDARY = '#666666';
